<template>

  <div v-bind='$attrs'>
    <label
      v-if='label'
      data-cy='checkbox-multi-label'
      class='mb-2 block text-sm font-medium'
      :class='[(disabled && editMode) ? "text-gray-400" : "text-gray-700"]'
    >
      <QuestionMarkCircleIcon
        v-if='help'
        class='question-mark-circle-icon mb-1 mr-0.5 inline-block h-4 w-4 cursor-pointer'
        @click='setHelpModalVisibility(true)'
      />
      <span
        :title='label'
        v-html='getLabel()'
      />
    </label>
    <div v-if='editMode'>
      <div class='relative mt-1'>
        <fieldset
          class='space-y-3'
          :disabled='disabled'
        >
          <CheckboxField
            v-for='(option, index) in field.values'
            :key='index'
            :label='option.label'
            :name='option.value'
            :field='field'
            :description='option.description'
            :model-value='isToggled(option.value)'
            :disabled='disabled'
            :edit-mode='editMode'
            @update:model-value='emittedValue(option.value)'
          />
        </fieldset>
      </div>
      <InputError :error='error'/>
    </div>
    <div
      v-else
      class='space-y-3'
    >
      <StaticListItem
        v-for='(option, index) in field.values'
        :key='index'
        :label='option.label'
        :description='option.description'
        :checked='isToggled(option.value)'
      />
    </div>
  </div>
  <Modal
    :open='helpVisible'
    :title='label'
    @close-modal='setHelpModalVisibility(false)'
  >
    <template #content>
      <p v-html='help'/>
    </template>
  </Modal>
</template>

<script lang="ts">
  import { defineComponent, onMounted } from 'vue'
  import useInputFieldBase, { InputFieldProps, InputFieldComponents, InputFieldEmits } from '../../../compositions/useInputFieldBase'
  import useInputFieldHasHelp, { InputFieldHasHelpProps, InputFieldHasHelpComponents } from '../../../compositions/useInputFieldHasHelp'
  import CheckboxField from './CheckboxField.vue'
  import StaticListItem from '../base/StaticListItem.vue'

  export default defineComponent({
    name: 'CheckboxMultiField',
    components: {
      StaticListItem,
      ...InputFieldComponents,
      ...InputFieldHasHelpComponents,
      CheckboxField,
    },
    props: {
      ...InputFieldProps,
      ...InputFieldHasHelpProps,
    },
    emits: [
      ...InputFieldEmits,
    ],
    setup: function (props) {
      const { helpVisible, setHelpModalVisibility } = useInputFieldHasHelp()
      const { updateValue, getLabel } = useInputFieldBase()

      onMounted(() => {
        if (!props.modelValue) {
          updateValue([])
        }
      })

      function emittedValue(value: string) {
        toggleValue(value)
      }
      function toggleValue(value: string) {
        if (!props.disabled) {
          const newValue = props.modelValue.includes(value) ? props.modelValue.filter(v => v !== value) : [...props.modelValue, value]

          updateValue(newValue)
        }
      }

      function isToggled(option: string | number) {
        if (!props.modelValue || props.modelValue.length === 0) {
          return false
        }

        return props.modelValue.includes(option) ? 'checked' : false
      }

      return {
        updateValue, getLabel, helpVisible, setHelpModalVisibility, emittedValue, toggleValue, isToggled,
      }
    },
  })
</script>
